import { render, staticRenderFns } from "./AwaitingExportExpensesIndicators.vue?vue&type=template&id=50832eb2&"
import script from "./AwaitingExportExpensesIndicators.vue?vue&type=script&lang=js&"
export * from "./AwaitingExportExpensesIndicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports